(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-premium-inside"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeInside(root) {
    root.querySelectorAll('[data-inside-disclosure]').forEach(wrapper => {
      if (wrapper.dataset.ready) return;
      wrapper.dataset.ready = 'true';
      const content = wrapper.querySelector('.bgp-inside-collapsible');
      const button = wrapper.querySelector('button');
      const column = wrapper.closest('.bgp-inside-copy');
      const grid = column.parentElement;
      const update = () => {
        const previews = grid.querySelector('.bgp-previews');
        const heading = column.querySelector('h2');
        const cta = column.querySelector('.bgp-inside-cta-form');
        const desktop = window.matchMedia('(min-width:900px)').matches;
        const available = desktop && previews ? previews.offsetHeight - (heading?.offsetHeight || 40) - (cta?.offsetHeight || 0) - 80 : 300;
        const limit = Math.max(280,Math.min(640,available));
        wrapper.style.setProperty('--inside-preview-height', limit + 'px');
        const long = content.scrollHeight > limit + 60;
        wrapper.classList.toggle('is-collapsible', long);
        button.hidden = !long;
      };
      button.addEventListener('click', () => {
        const open = wrapper.classList.toggle('is-open');
        button.setAttribute('aria-expanded',String(open));
        button.textContent = open ? 'Read less' : 'Read more';
      });
      update();
      const observer = new ResizeObserver(update);
      observer.observe(grid);
      grid.querySelectorAll('img').forEach(img => img.addEventListener('load',update,{once:true}));
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initializeInside(document));
  else initializeInside(document);
  document.addEventListener('shopify:section:load',event=>initializeInside(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
